import { uiDefaultTooltipIcon, UiFormTooltipIcon } from "@webapp/ui/form/form.models";

export function formToTooltipIcon(value: string | UiFormTooltipIcon): Required<UiFormTooltipIcon> {
  const icon = typeof value === "string" ? { type: value } : value;
  return { ...uiDefaultTooltipIcon, ...icon };
}
